// @flow
import * as React from 'react';
import { useSnackbar } from 'notistack';

import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';

import { DISMISS } from 'constants/strings';

type OpenSnackbarProps = {
  message: React.Node,
  id: string,
  action?: React.Node,
  autoHideDuration?: number,
  autoHide?: boolean,
  dismissable?: boolean,
};

type Value = {
  openSnackbar?: (OpenSnackbarProps) => void,
};

const defaultValues = {
  openSnackbar: undefined,
};

export const SnackbarContext = React.createContext<Value>(defaultValues);

const DismissButton = ({ size, ...restProps }) => {
  if (size === 'small') {
    return (
      <IconButton key="close" aria-label="Close" color="inherit" {...restProps}>
        <CloseIcon />
      </IconButton>
    );
  }

  return (
    <Button color="secondary" size="small" {...restProps}>
      {DISMISS}
    </Button>
  );
};

export const SnackbarContextProvider = ({
  children,
}: {
  children: React.Node,
}) => {
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();

  const handleCloseSnackbar = (key) => {
    closeSnackbar(key);
  };

  const handleOpenSnackbar = ({
    message,
    id,
    action,
    autoHide = true,
    autoHideDuration = 3000,
    dismissable,
  }: OpenSnackbarProps) => {
    enqueueSnackbar(message, {
      key: id,
      autoHideDuration,
      preventDuplicate: true,
      persist: !autoHide,
      action: (key) => (
        <DismissButton
          key={`snackbar-dismiss-button-${key}`}
          size={action ? 'small' : 'large'}
          onClick={() => handleCloseSnackbar(key)}
        />
      ),
    });
  };

  return (
    <SnackbarContext.Provider
      value={{
        openSnackbar: handleOpenSnackbar,
      }}
    >
      {children}
    </SnackbarContext.Provider>
  );
};

export default SnackbarContext;
